
      var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGift = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.482 2.762c1.019-.975 2.69-1.014 3.762-.117l.13.117 3.254 3.114a.91.91 0 0 1-1.17 1.387l-.087-.073-3.254-3.115c-.358-.343-1.02-.343-1.378 0-.232.223-.256.517-.07.754l.07.076 1.028.984a.91.91 0 0 1-1.17 1.387l-.087-.074-1.027-.983c-1.008-.963-1.008-2.494-.001-3.457",
  fill: "var(--theme-primary, #9631ff)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.615 2.76c1.064-1.014 2.836-1.014 3.9 0 .968.924 1.009 2.37.12 3.337l-.12.123-1.032.983a.91.91 0 0 1-1.332-1.232l.078-.083 1.031-.984c.26-.247.26-.58 0-.828-.334-.317-.928-.342-1.302-.073l-.088.074-3.243 3.091a.909.909 0 0 1-1.332-1.232l.078-.084z",
  fill: "var(--theme-primary, #9631ff)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 5.636a.91.91 0 0 1 .903.803l.006.106v14.546a.91.91 0 0 1-1.812.106l-.006-.106V6.545A.91.91 0 0 1 12 5.636",
  fill: "#000"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.09 5.636a.91.91 0 0 1 .91.91v4.545a.91.91 0 0 1-.91.909H2.91a.91.91 0 0 1-.91-.91V6.547a.91.91 0 0 1 .91-.91zM3.819 7.455v2.727h16.364V7.455z",
  fill: "#000"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.182 10.182a.91.91 0 0 1 .909.909v10a.91.91 0 0 1-.91.91H3.819a.91.91 0 0 1-.909-.91v-10a.91.91 0 0 1 .91-.91zM4.728 12v8.182h14.545V12z",
  fill: "#000"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M5.482 2.762c1.019-.975 2.69-1.014 3.762-.117l.13.117 3.254 3.114a.91.91 0 0 1-1.17 1.387l-.087-.073-3.254-3.115c-.358-.343-1.02-.343-1.378 0-.232.223-.256.517-.07.754l.07.076 1.028.984a.91.91 0 0 1-1.17 1.387l-.087-.074-1.027-.983c-1.008-.963-1.008-2.494-.001-3.457\" fill=\"var(--theme-primary, #9631ff)\"/><path d=\"M14.615 2.76c1.064-1.014 2.836-1.014 3.9 0 .968.924 1.009 2.37.12 3.337l-.12.123-1.032.983a.91.91 0 0 1-1.332-1.232l.078-.083 1.031-.984c.26-.247.26-.58 0-.828-.334-.317-.928-.342-1.302-.073l-.088.074-3.243 3.091a.909.909 0 0 1-1.332-1.232l.078-.084z\" fill=\"var(--theme-primary, #9631ff)\"/><path d=\"M12 5.636a.91.91 0 0 1 .903.803l.006.106v14.546a.91.91 0 0 1-1.812.106l-.006-.106V6.545A.91.91 0 0 1 12 5.636\" fill=\"#000\"/><path d=\"M21.09 5.636a.91.91 0 0 1 .91.91v4.545a.91.91 0 0 1-.91.909H2.91a.91.91 0 0 1-.91-.91V6.547a.91.91 0 0 1 .91-.91zM3.819 7.455v2.727h16.364V7.455z\" fill=\"#000\"/><path d=\"M20.182 10.182a.91.91 0 0 1 .909.909v10a.91.91 0 0 1-.91.91H3.819a.91.91 0 0 1-.909-.91v-10a.91.91 0 0 1 .91-.91zM4.728 12v8.182h14.545V12z\" fill=\"#000\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/gift.154e1b861b582299a4188884b9751a42.svg"),
        {
          React: SvgGift,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      